export const ADD_MENU_DETAILS = 'ADD_MENU_DETAILS';
export const REMOVE_MENU_DETAILS = 'REMOVE_MENU_DETAILS';